//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import { badgeProps, avatarProps } from "./objectForList";

export default {
    name: "AQList",
    components: {
        AQAvatar,
        AQBadge,
        AQListBtn,
        AQTooltip
    },
    /* INFO
        - disableBtns => disable all visible btns, or if you want to disable a specific button,
                         add inside each element in the list the property like:
                         disableEdit: true/false, disableDownload, disableCopy, disableDelete, disableMore
    */
    props: {
        list: { type: Array, required: true, default: () => [] }, // big and small list
        // props for button component
        hideAllBtn: { type: Boolean, default: false }, // hide btn sections
        hideList: { type: Array, default: () => [] }, // list of buttons to hide
        optionsMore: { type: Array, default: () => [] }, // options for more button
        disableBtns: { type: Boolean, default: false }, // see above for info
        // big list
        hasBadgeLeft: { type: Boolean, default: false }, // big list
        hasBadgeRight: { type: Boolean, default: false }, // big list
        isBig: { type: Boolean, default: false }, // big list
        propsForBadgeLeft: { type: Object, default: () => {} }, // {badgeType: "systemType", badgeText: "appName"}
        propsForBadgeRight: { type: Object, default: () => {} }, // {badgeType: "systemType", badgeText: "appName"}
        leftText: { type: String, default: "" },
        propsForAvatar: { type: Object, default: () => {} }, //  {type: "avatarType", customAvatar:"avatarPath"},
        customCopyLabel: { type: String, default: "" },
        customDownloadLabel: { type: String, default: "" },
        noAvatar: { type: Boolean, default: false },
        showCaption: { type: Boolean, default: false } // shows caption for the case when isBig is false
    },
    data() {
        return {
            hovered: null,
            actionName: null,
            idx: null,
            openRow: false,
            hideRowBtns: false
        };
    },
    computed: {
        checkBtns() {
            return this.$scopedSlots.moreBtnSlot || !this.hideAllBtn;
        }
    },

    methods: {
        setName(item) {
            let name = null;
            if (item.firstName && item.lastName) {
                name = item.firstName.concat(" ", item.lastName);
            } else {
                name = item.name || item.firstName || item.lastName;
            }
            return name;
        },
        setCaption(item) {
            return item.email;
        },
        propsAvatar(item) {
            const { type, customAvatar, defaultAvatar, disabled, firstAvatar } = this.propsForAvatar;
            let newAvatar = "";
            if (firstAvatar && item[firstAvatar.name]) {
                newAvatar = this.setAvatar(firstAvatar.value);
            } else {
                newAvatar = this.setAvatar(item[type]);
            }
            return {
                disabled: disabled ? this.setDisabled(item[disabled]) : false,
                type: newAvatar || defaultAvatar,
                customAvatar: item[customAvatar] ? this.setImage(item) : ""
            };
        },
        propsBadgeLeft(item) {
            const { badgeText, badgeType, badgeColor, noBorder, background, firstBadge } = this.propsForBadgeLeft;
            let newBadge = "";
            if (firstBadge && item[firstBadge.name]) {
                newBadge = this.setBadgeType(firstBadge.value);
            } else {
                newBadge = this.setBadgeType(item[badgeType]);
            }
            return {
                badgeText: item[badgeText],
                badgeType: newBadge,
                badgeColor: badgeColor || "",
                noBorder,
                background
            };
        },
        propsBadgeRight(item) {
            const { badgeText, badgeType, badgeColor, noBorder, background, firstBadge } = this.propsForBadgeRight;
            let newBadge = "";
            if (firstBadge && item[firstBadge.name]) {
                newBadge = this.setBadgeType(firstBadge.value);
            } else {
                newBadge = this.setBadgeType(item[badgeType]);
            }
            return {
                badgeText: item[badgeText],
                badgeType: newBadge,
                badgeColor: item.customColor || badgeColor || "",
                noBorder,
                background: item.customBackground || background
            };
        },
        click(action, item, index) {
            this.actionName = action;
            this.openRow = true;
            this.idx = index;
            this.hideRowBtns = false;
            if (action) {
                this.$emit("input", { action, item, index });
            }
        },
        openElement(event) {
            if ((this.actionName && this.actionName !== "more") || (!this.openRow && typeof event === "object")) {
                this.$emit("edit", event);
            }
            this.openRow = false;
        },
        setBadgeType(value) {
            const defaultBadge = "Platform";
            const findValue = badgeProps.find(elem => elem.type === value);
            return findValue ? findValue.value : defaultBadge;
        },
        setAvatar(value) {
            const findValue = avatarProps.find(elem => elem.type === value);
            return findValue ? findValue.value : "";
        },
        setDisabled(value) {
            let valueToReturn = false;
            if (typeof value === "boolean") {
                valueToReturn = !value;
            } else if (value && value.toLowerCase() === "disabled") {
                valueToReturn = true;
            }
            return valueToReturn;
        },
        setImage(item) {
            return `/identity/tenants/users/image/${item.id}/s`;
        }
    }

};
